import EmberObject from '@ember/object';

export default class VoltageRangeRate extends EmberObject {
  value; // double
  frequency; // double
  warningEnabled; // boolean
}
